<div class="availability-blocks-container" [class.compact]="compact">
  <ng-container *ngIf="availability && availability.length > 0">
    <div class="availability-blocks">
      <div class="availability-block"
           *ngFor="let slot of getDisplayedAvailability()">
        <mat-icon class="time-icon">schedule</mat-icon>
        <span class="day-code">{{ getDayName(slot.dayOfWeek) }}</span>
        <span class="time-range">{{ slot.startTime }} - {{ slot.endTime }}</span>
      </div>

      <button class="expand-button"
              *ngIf="getRemainingCount() > 0 || expanded"
              (click)="toggleExpanded(); $event.stopPropagation()"
              type="button">
        <mat-icon class="expand-icon">{{ expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
        <span>{{ expanded ? 'Show less' : '+' + getRemainingCount() + ' more' }}</span>
      </button>
    </div>
  </ng-container>

  <div class="no-availability" *ngIf="!availability || availability.length === 0">
    <mat-icon class="no-icon">event_busy</mat-icon>
    <span>No availability set</span>
  </div>
</div>